import dayjs from "dayjs"
import { safeDayjs } from "@/helpers/dateHelper"
import IParser from "@/types/IParser"
import { ThrottleEventResponse } from "@/api/backofficeRest/generated/model"
import { IThrottleEvent, ThrottleEventStatus } from "./throttleEvent.types"
import { ThrottleEvent } from "./throttleEvent"

export type ThrottleEventRaw = ThrottleEventResponse

export const ThrottleEventParser: IParser<IThrottleEvent, ThrottleEventRaw> = {
  toDomain(data: ThrottleEventRaw): IThrottleEvent {
    return new ThrottleEvent(
      data.id,
      data.communicationName,
      dayjs(data.windowStart),
      data.windowSeconds,
      data.maxPerWindow,
      data.emailsSent,
      data.emailsThrottled,
      data.status as ThrottleEventStatus,
      data.resumedBy ?? null,
      safeDayjs(data.resumedAt),
      data.discardedBy ?? null,
      safeDayjs(data.discardedAt),
    )
  },
}
